import React from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft, faShare } from '@fortawesome/free-solid-svg-icons'
import { SRLWrapper } from 'simple-react-lightbox'
import { TextButton, PrimaryButton } from '../../styles'
import { FormBodyContent, FormInfoText, FormActions } from './'
import { isNotNull } from '../../utils'
import { onboardingScreen } from '../../constants/onboardingScreen'
import { routes } from '../../navigation/CONSTANTS'

class GenerateExchangeKeys extends React.Component {
    constructor(props) {
        super(props)

        this.state = { }
        this.mounted = false
    }

    componentDidMount() {
        this.mounted = true
    }

    componentDidUpdate(prevProps) {
        if (this.mounted) {
            const { skipOnboarding } = this.props
            if (isNotNull(skipOnboarding) && prevProps.skipOnboarding !== skipOnboarding && !skipOnboarding.loading) {
                const { response } = skipOnboarding
                if (isNotNull(response) && response.success) window.location.href = routes.dashboard
            }
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }

    handleClickNext = (e) => {
        e.preventDefault()

        const { eventHandlers } = this.props
        if (isNotNull(eventHandlers)) {
            eventHandlers.navigateTo(null, onboardingScreen.SECURITY_VERIFICATION)
        }
    }

    handleClickBack = (e) => {
        e.preventDefault()

        const { eventHandlers } = this.props
        if (isNotNull(eventHandlers)) {
            eventHandlers.navigateTo(null, onboardingScreen.BINANCE_API_SETTINGS)
        }
    }

    showSkipWarning = (e) => {
        const { eventHandlers } = this.props
        eventHandlers.handleSkip(e)
    }

    render() {
        const lightboxOptions = {
            buttons: {
                showAutoplayButton: false,
                showThumbnailsButton: false
            }
        }

        return (
            <>
                <FormBodyContent className='api-connection'>
                    <div className='graphic with-preview notransform'>
                        <SRLWrapper options={lightboxOptions}>
                            <img src="/images/form-graphics/step-3.gif" alt="Generate exchange API keys in Binance.com" style={{ width: '100%' }} />
                        </SRLWrapper>
                    </div>

                    <div className='form'>
                        <h2 className='form-title'>Connect PF to Binance.com</h2>
                        <h3 className='form-instruction'>Create API keys inside Binance.com</h3>

                        <Form.Group className='detailed-instructions'>
                            <ol>
                                <li>Enter a name to label your API key (eg. PF API)</li>
                                <li>Click Create API button</li>
                            </ol>
                        </Form.Group>
                    </div>
                </FormBodyContent>

                <FormInfoText type="list">
                    <label><strong>Note: </strong></label>
                    <ul>
                        <li>You need to have verified your account (KYC) in order to create API keys.</li>
                    </ul>
                </FormInfoText>

                <FormActions>
                    <TextButton 
                        textColor="#8A9BAE"
                        size="sm" 
                        className='default-btn back-btn'
                        onClick={(e) => this.handleClickBack(e)}>
                            <FontAwesomeIcon size="xs" className='icon' icon={faArrowLeft} /> 
                            <span>Back</span>
                    </TextButton>
                    
                    <TextButton 
                        textColor="#8A9BAE"
                        size="auto" 
                        className='default-btn skip-btn' 
                        onClick={(e) => this.showSkipWarning(e)}>
                            <FontAwesomeIcon size="xs" className='icon' icon={faShare} /> 
                            <span>Skip</span>
                    </TextButton>

                    <PrimaryButton 
                        type="submit" 
                        size="sm"
                        onClick={(e) => this.handleClickNext(e)}>
                            <FontAwesomeIcon size="xs" className='icon' icon={faArrowRight} /> 
                            <span>Next</span>
                    </PrimaryButton>
                </FormActions>
            </>
        )
    }
}

function mapStateToProps(state) {
    const { skipOnboarding } = state
    return {
        skipOnboarding
    }
}

const connectedGenerateExchangeKeys = connect(mapStateToProps)(GenerateExchangeKeys)
export { connectedGenerateExchangeKeys as GenerateExchangeKeys }